/** @format */

import React, { FunctionComponent, useState } from 'react';
import { ProductRemoveType } from './ProductRemove';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import I18 from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import moment, { Moment } from 'moment';
import Datetime from 'react-datetime';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ConfigWrapper } from '../../../core/ConfigWrapper';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';
import { ProductActions } from '../../../modules/simcard/ProductReducer';

type ProductRemoveActionType = ProductRemoveType & { open: boolean; setOpenDialog: (open: boolean) => void };

export const ProductRemoveNotPortingPrepare: FunctionComponent<ProductRemoveActionType> = ({ classes, product, itemLoader, open, setOpenDialog }) => {
    const configWrapper = new ConfigWrapper();
    let defaultDeleteDate = moment();
    if (product.removePeriod) {
        defaultDeleteDate = moment(product.removePeriod);
    } else {
        defaultDeleteDate.add(configWrapper.getDefaultProductDeactivationDays(), 'days');
    }
    const [height, setHeight] = useState('100px');
    const [deletedDate, setDeletedDate] = useState(defaultDeleteDate);
    const [openCalendar, setOpenCalendar] = useState(false);
    const dispatch = useDispatch();
    const confirmDelete = (): void => {
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + product.id),
            'deleted_product_setup_no_dispatch',
            {
                id: product.id,
                deleteSimCard: true,
                deletedAt: deletedDate.format('YYYY-MM-DD'),
            },
            (data: any): void => {
                setOpenDialog(false);
                dispatch({ type: ProductActions.PRODUCT_REFRESH_VIEW, uri: product['@id'] });
            }
        );
    };
    const rejectDelete = (): void => {
        setDeletedDate(defaultDeleteDate);
        setOpenCalendar(false);
        setHeight('100px');
        setOpenDialog(false);
    };

    return (
        <Dialog open={open} onClose={rejectDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <I18n trans="simcard:edit.planned_delete_sim_card" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={3} />
                    <GridItem xs={6} style={{ height: height, overflow: 'hidden' }}>
                        <FormControl className={classes.formControl} style={{ minWidth: '100px' }}>
                            <Datetime
                                timeFormat={false}
                                locale="pl"
                                defaultValue={deletedDate}
                                viewDate={deletedDate}
                                closeOnSelect={false}
                                dateFormat={true}
                                open={openCalendar}
                                onChange={(moment: Moment | string): void => {
                                    if (typeof moment === 'object') {
                                        setDeletedDate(moment);
                                    }
                                }}
                                inputProps={{
                                    id: 'deletedDate',
                                    placeholder: 'YYYY-MM-DD',
                                    onKeyPress: (e: any): void => {},
                                }}
                                onFocus={(): void => {
                                    setHeight('350px');
                                    setOpenCalendar(true);
                                }}
                                disableOnClickOutside={true}
                            />
                            <FormHelperText id={'helpText-text'}>
                                <I18 trans="simcard:edit.planned_deleted_date" />
                            </FormHelperText>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={3} />
                    <GridItem xs={12}>
                        <I18n trans="simcard:edit.planed_deleted_message" />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={rejectDelete} callbackParam={{}} label="simcard:edit.expiration_cancel" size="sm" />
                <CustomTextButtom callback={confirmDelete} callbackParam={{}} label="simcard:edit.expiration_setup" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
